<template>
  <v-container fluid class="participant-list pa-0">
    <v-data-table :headers="headers"
                  :items="participants"
                  :footer-props="{itemsPerPageOptions: [10, 20, 50], showFirstLastPage: true}"
                  multi-sort
                  :search="search"
                  fixed-header
                  :show-select="!hideSelect"
                  class="participant-list--table"
                  v-bind="$attrs">
      <template #header.data-table-select>
        <v-simple-checkbox :value="selectedItemIds.length === participants.length"
                           @input="selectedAllToggled"
                           :ripple="false"></v-simple-checkbox>
      </template>
      <template #item.data-table-select="{item, select}">
        <v-simple-checkbox :value="selectedItemIds.indexOf(item.id) !== -1"
                           @input="itemSelected(item)"
                           :key="item.id"
                           :ripple="false"></v-simple-checkbox>
      </template>
      <template #item.create_at="{value}">
        {{ $parseDate(value) }}
      </template>
      <template #item.name="{item}">
        {{ `${item.account.surname} ${item.account.given_name}` }}
      </template>
      <template #item.account.last_participant_status="{value}">
        {{
          {
            null: 'N/A',
            1: $t('admin_participant.accepted'),
            '-1': $t('admin_participant.rejected'),
          }[value]
        }}
      </template>
      <template #item.enrollment.event.name="{value}">
        {{ $sanitizeHtml(value) }}
      </template>
      <template #item.enrollment.session.order_no="{item}">
        <div v-if="item.enrollment.session">
          <div><b>{{ item.enrollment.session.name }}</b></div>
          <div>{{ $parseDate(item.enrollment.session.start, 'd/M/y, T') }} - {{ $parseDate(item.enrollment.session.end, 'T') }}</div>
        </div>
      </template>
      <template #item.meta="{item}">
        {{ getItemMeta(item) }}
      </template>
      <template #item.status="{value}">
        {{
          {
            0: $t('admin_participant.pending'),
            1: $t('admin_participant.accepted'),
            "-1": $t('admin_participant.rejected'),
          }[value]
        }}
      </template>
      <template #item.enrollment.notifications="{item, value}">
        <v-btn icon
               v-if="value.length > 0"
               @click="showParticipantNotifications(item)">
          <v-icon>fas fa-paper-plane</v-icon>
        </v-btn>
      </template>
      <template #item.checkin_time="{item}">
        {{ getParticipantCheckInTime(item) }}
      </template>
      <template v-slot:item.actions="{item}">
        <v-row>
          <v-col>
            <font-awesome-icon icon="edit"
                               @click="editItem(item)"></font-awesome-icon>
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <EnrollmentNotificationRecordModal :enrollment-id="showingParticipantId"
                                       :shown="participantNotificationModalShown"
                                       @cancel="participantNotificationModalShown = false"></EnrollmentNotificationRecordModal>
  </v-container>
</template>

<script>
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import _ from "lodash";
import EnrollmentNotificationRecordModal from "@/components/event/enrollment/EnrollmentNotificationRecordModal";

export default {
  name: 'ParticipantList',
  components: {EnrollmentNotificationRecordModal},
  props: {
    search: String,
    eventId: String,
    sessionId: String,
    seriesId: String,
    userId: String,
    participantId: String,
    refreshTrigger: Boolean,
    feeTiers: String,
    hideSelect: Boolean,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      getParticipants();
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        {text: root.$t('admin_company.name_en'), value: 'name_en', contains: true},
        {text: root.$t('admin_company.name_zh'), value: 'name_zh', contains: true},
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_participant.event'), value: 'enrollment.event.name'},
      {text: root.$t('admin_participant.session'), value: 'enrollment.session.order_no'},
      {text: root.$t('admin_participant.account'), value: 'name'},
      {text: root.$t('admin_participant.company'), value: 'account.company.name'},
      {text: root.$t('admin_participant.checkin_time'), value: 'checkin_time'},
      {text: root.$t('admin_participant.manual_check_in'), value: 'manual_check_in'},
      {text: root.$t('admin_enrollment.email_status'), value: 'enrollment.notifications'},

      // {text: '', value: 'actions', sortable: false},
    ]);

    const participants = ref([]);
    const getParticipants = function () {
      root.$callAPI('hkiarace/admin/event/participant/', {
        event_id: props.eventId,
        session_id: props.sessionId,
        series_id: props.seriesId,
        user_id: props.userId,
      }, function (response) {
        participants.value = response.body.participants;
      });
    };
    const getItemMeta = function (item) {
      if (props.feeTiers) {
        let meta = JSON.parse(item.meta);
        let fee_tiers = JSON.parse(props.feeTiers);
        let result = '';

        fee_tiers.forEach((t) => {
          if (meta[t['id']]) {
            result += root.$localeGet(t, 'name') + ': ' + meta[t['id']];
          }
        });

        return result;
      }
    };

    const selectedAllToggled = function () {
      if (selectedItemIds.value.length !== participants.value.length) {
        selectedItemIds.value = participants.value.map((e) => e.id);
      } else {
        selectedItemIds.value = [];
      }
    }
    const itemSelected = function (item) {
      let idx = selectedItemIds.value.indexOf(item.id);

      if (idx === -1) {
        selectedItemIds.value = _.union(selectedItemIds.value, [item.id]);
      } else {
        let array = selectedItemIds.value;
        // _.remove(array, (i) => {
        //   return i === item.id;
        // });
        array.splice(idx, 1)
        selectedItemIds.value = array;
      }
    };
    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });


    const getParticipantCheckInTime = function (item) {
      if (item.check_in_records.length > 0) {
        const firstCheckInRecord = _.last(_.sortBy(item.check_in_records, 'create_at'));

        return root.$parseDate(firstCheckInRecord.checkin_time);
      }

      return '';
    };

    const showingParticipantId = ref(null);
    const participantNotificationModalShown = ref(false);
    const showParticipantNotifications = function (item) {
      showingParticipantId.value = item.enrollment.id;
      participantNotificationModalShown.value = true;
    };

    const editItem = function (item) {
      emit('edit', item);
    };

    return {
      filterOptions,

      headers,
      participants,

      getItemMeta,

      selectedAllToggled,
      itemSelected,
      selectedItemIds,

      getParticipantCheckInTime,

      showingParticipantId,
      participantNotificationModalShown,
      showParticipantNotifications,

      editItem,
    }
  }
}
</script>

<style lang="less">
.participant-list {
  display: flex;
  flex-direction: column;
  height: 100%;

  .participant-list--table {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;

    .v-data-table__wrapper {
      flex: 1 1 0;
    }

    .v-data-footer {
      margin-right: 0 !important;
    }
  }
}
</style>
